import app from './AppReducer';

export default app;
